import { useMemo } from 'react';
import VirtualSettingsAttendeeApiClient from 'lib/SplashApiClient/subclients/VirtualSettingsAttendeeApiClient'; // eslint-disable-line max-len
import getSplashApiClient from 'lib/SplashApiClient/singleton';

/**
 * This hook is used to create the virtualSettingsAPI client used accross all of our needed requests.
 *
 * @param {Object{ vepTokens }} props - A props list with the current VEP tokens.
 * @return { VirtualSettingsAttendeeApiClient } - The virtual settings attendee api client.
 */
const useVirtualSettingsAttendeeApiClient = ({ vepTokens }) =>
    useMemo(
        () =>
            new VirtualSettingsAttendeeApiClient(
                getSplashApiClient(),
                vepTokens?.guestAccessHash,
                vepTokens?.accessToken,
            ),
        [vepTokens?.guestAccessHash, vepTokens?.accessToken],
    );

export default useVirtualSettingsAttendeeApiClient;
